import React from 'react';
import type { Test } from '@mariana/labos-client';
import { getResultViewer } from '../config/viewsConfig';
import { ICPResultViewer } from './result-viewers/ICPResultViewer';
import { NMRResultViewer } from './result-viewers/NMRResultViewer';
import { LoiResultViewer } from './result-viewers/LoiResultViewer';
import { OilInWaterResultViewer } from './result-viewers/OilInWaterResultViewer';
import { ShimadzuResultViewer } from './result-viewers/ShimadzuResultViewer';
import { TitratorResultViewer } from './result-viewers/TitratorResultViewer';
import { CamsizerResultViewer } from './result-viewers/CamsizerResultViewer';
import { WorksheetViewer } from './WorksheetViewer';
import './EntityDetail.css';

interface ResultsViewerProps {
  test: Test;
}

export const ResultsViewer: React.FC<ResultsViewerProps> = ({ test }) => {
  const assayId = test.attributes?.assay_id as number | undefined;
  const viewerKey = assayId != null ? getResultViewer(assayId) : undefined;

  switch (viewerKey) {
    case 'icp':
      return <ICPResultViewer test={test} />;
    case 'nmr':
      return <NMRResultViewer test={test} />;
    case 'shimadzu':
      return <ShimadzuResultViewer test={test} />;
    case 'oilInWater':
      return <OilInWaterResultViewer test={test} />;
    case 'titrator':
      return <TitratorResultViewer test={test} />;
    case 'loi':
      return <LoiResultViewer test={test} />;
    case 'camsizer':
      return <CamsizerResultViewer test={test} />;
    default: {
      const rawWorksheetData = test.attributes?.raw_worksheet_data as Record<string, Record<string, any>> | undefined;
      if (rawWorksheetData) {
        return <WorksheetViewer rawWorksheetData={rawWorksheetData} />;
      }
      return (
        <div className="events-empty-state">
          No result viewer available for this test type.
        </div>
      );
    }
  }
};
